<template>
  <div class="relative w-full grid grid-cols-3">
    <!-- Tops Ads Skeleton -->
    <div class="space-y-2 border-r border-border-normal px-4 py-3">
      <div v-for="n in 3" :key="`top-ad-skeleton-${n}-${lensId}`" class="p-1">
        <div class="flex justify-center items-center gap-3">
          <BaseText type="label" size="sm" class="text-text-disabled">
            {{ n }}
          </BaseText>
          <div class="skeleton w-16 h-16 rounded-md" />
          <div class="flex-1 space-y-3 flex-shrink min-w-0">
            <div class="skeleton w-full h-5 rounded-md" />
            <div class="skeleton w-1/2 h-5 rounded-md" />
          </div>
        </div>
      </div>
    </div>
    <!-- Overview Stats Skeleton -->
    <div class="col-span-2 flex flex-col">
      <div class="grid grid-cols-3" style="height: 112px;">
        <div v-for="(stat, index) in statPlaceholders" :key="`overview-stat-skeleton-${index}-${lensId}`"
        :class="index !== 2 ? 'border-r' : ''">
          <div class="h-28 p-4 border-b border-border-normal flex flex-col">
            <div class="flex items-center gap-1">
              <BaseText type="label" size="sm" class="text-text-disabled whitespace-nowrap truncate">
                {{ stat }}
              </BaseText>
              <InfoIcon class="text-text-disabled" />
            </div>
            <div class="skeleton w-1/3 h-6 rounded-md mt-2" />
            <div class="skeleton w-2/3 h-5 rounded-md mt-3" />
          </div>
        </div>
      </div>
      <div class="p-4 flex flex-col" style="height: 148px;">
        <div class="flex items-center gap-1.5">
          <BenchmarkIcon class="text-text-disabled" />
          <BaseText type="label" size="sm" class="text-text-disabled">
            Benchmarks
          </BaseText>
        </div>
        <div class="flex-grow flex flex-wrap mt-3 gap-y-3">
          <div v-for="benchmark in benchmarkPlaceholders" :key="`benchmark-stat-skeleton-${benchmark}-${lensId}`"
          class="grid grid-cols-12 w-full place-items-center justify-items-start" style="max-width: 50%">
            <BaseText class="w-1/4 text-text-disabled col-span-3" size="sm">
              {{ benchmark }}
            </BaseText>
            <div class="skeleton col-span-9 w-full h-5 rounded-md" style="max-width: 70%" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfoIcon from '../../globals/Icons/InfoSimpleIcon.vue'
import BenchmarkIcon from '../../globals/Icons/LensIcons/BenchmarkIcon.vue'

export default {
  name: 'LensOverviewCardSkeleton',
  components: {
    InfoIcon,
    BenchmarkIcon
  },
  props: {
    lensId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      statPlaceholders: [
        'Spend',
        'Goal Metric',
        'New Creative Velocity'
      ],
      benchmarkPlaceholders: ['CPA', 'CPM', 'CVR', 'ROAS', 'CPC']
    }
  }
}
</script>